import React from 'react'
import injectSheet from 'react-jss'
import styles from './info-message.styles'
import PaperclipIcon from 'react-icons/lib/fa/paperclip'

const InfoMessage = ({ classes, student, worksCount }) => (
  <p className={classes.message}>
    <PaperclipIcon className={classes.icon} />
    Moderation file with {worksCount} piece
    {worksCount > 1 ? 's' : ''} by {student} attached
  </p>
)

export default injectSheet(styles)(InfoMessage)
